// extracted by mini-css-extract-plugin
module.exports = {"box":"GrowWrapper_box__1VjTg"};